lmApp.service('CategoryService', ['$rootScope', 'AssetService',
  function ($rootScope, AssetService) {
    var service = {};
    var data = [];
    var NAMESPACE = 'categories:update';

    service.fetchCategories = function () {
      AssetService.GetCategoryCollection()
        .then(function (collection) {
          data = collection
            .map(function (category) {
              return Object.assign({}, category, {type: 'category'});
            })
            .filter(function (category) {
              return category.id;
            });

          $rootScope.$broadcast(NAMESPACE, data);
        });
    };

    service.getCategories = function () {
      return angular.copy(data);
    };

    service.subscribeOnUpdate = function (scope, callback) {
      scope.$on(NAMESPACE, callback);
    };

    service.fetchCategories();

    return service;
  }
]);
